import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=cb2ee032&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"
import style0 from "./inbox.vue?vue&type=style&index=0&id=cb2ee032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ee032",
  null
  
)

export default component.exports